import Router from "./router";
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";
import React from "react";
import "./translates"
import {BrowserRouter} from "react-router-dom";

function App() {
  return (
      <BrowserRouter>
          <I18nextProvider i18n={i18next}>
              <Router/>
          </I18nextProvider>
      </BrowserRouter>
  );
}

export default App;
